import React, { useState, useEffect, useRef } from "react";

const BonusDropDown = ({
  width,
  label,
  selected,
  setSelected,
  options,
  isRequired,
  style,
  className,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Sync selectedLabel with selected prop whenever it changes
  useEffect(() => {
    if (selected) {
      const selectedOption = options.find((opt) => opt.id === selected);
      if (selectedOption) {
        setSelectedLabel(selectedOption.label);
      }
    } else {
      setSelectedLabel("");
    }
  }, [selected, options]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Calculate dropdown position when opening
  useEffect(() => {
    if (isActive && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY + 2,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [isActive]);

  // Update position on scroll
  useEffect(() => {
    if (!isActive) return;

    const handleScroll = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + window.scrollY + 2,
          left: rect.left + window.scrollX,
          width: rect.width,
        });
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [isActive]);

  const handleClick = (option) => {
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div className={`dropdown-CB ${className}`} style={{ width, ...style }}>
      {label && (
        <label className="dropdown-CB-label">
          {label}
          {isRequired && <span>*</span>}
        </label>
      )}
      <div
        ref={buttonRef}
        className="dropdown-btn"
        onClick={() => setIsActive(!isActive)}
      >
        {selectedLabel || "-"}
        <img
          src={require("../../Assets/Images/CreateBatch/icon-dropdown-menu.png")}
          alt="dropdown-icon"
        />
      </div>
      {isActive && (
        <div
          ref={dropdownRef}
          className="dropdown-content-CBV2"
          style={{
            position: "fixed",
            top: `${dropdownPosition.top}px`,
            left: `${dropdownPosition.left}px`,
            width: `${dropdownPosition.width}px`,
            maxHeight: "200px",
            overflowY: "auto",
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 1000,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BonusDropDown;
